import React, { useEffect, useState } from 'react';
import { NoParamsFn } from 'tae/timesheets/types';
import { Dialog, ErrorButton } from '@beeline.com/bp-design-system';
import StyledDialogContent from 'src/components/finance/timeAndExpenses/timesheets/layout/dialog/DialogContent';
import { EngagementJobProfile } from './jobProfiles.mutations';
import { useJobProfilesIntl } from './translations/useJobProfilesIntl';

interface JobProfileDeleteDialogProps {
  show: boolean;
  isLoading: boolean;
  onClose: NoParamsFn;
  onSubmit: NoParamsFn;
  jobProfiles: EngagementJobProfile[];
  uids: string[];
}

export const JobProfileDeleteDialog: React.FC<React.PropsWithChildren<JobProfileDeleteDialogProps>> = ({
  show,
  isLoading,
  onClose,
  onSubmit,
  jobProfiles,
  uids
}) => {
  const intl = useJobProfilesIntl();
  const [formName, setFormName] = useState('');

  useEffect(() => {
    setFormName(jobProfiles.map((profile) => `"${profile?.name ?? ''}"`).join(', '));
  }, [jobProfiles]);

  const resultMessage = intl.confirmDeleteSmartForm({ formName, totalCount: uids.length });

  return (
    <Dialog
      open={show}
      onClose={onClose}
      dataTest="confirm-delete-job-profiles-dialog"
      title={intl.deleteJobProfile}
      show={{ cancelButton: true }}
      disableBackdropClick
      actions={[
        <ErrorButton.Contained key="confirm-button" dataTest="confirm-button" onClick={onSubmit} loading={isLoading}>
          {intl.confirmAndDelete}
        </ErrorButton.Contained>
      ]}
    >
      <StyledDialogContent style={{ padding: 0 }}>{resultMessage}</StyledDialogContent>
    </Dialog>
  );
};
